const ea = {
    "grooves":      0.6,
    "beams":        0.7,
    "lying":       0.7,
    "sprinkling":   0.75,
    "located":      0.9,
};
export default ea;